import client from '../httpClient';

const sendmailBukkenApi = (params) => {
  return client.post('/send-mails/bukken', params, { isShowMessage: true });
};

export default sendmailBukkenApi;
